/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { Dropdown } from 'react-native-element-dropdown';
import { Switch } from 'react-native-switch';
import { States } from '../types/props';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { useDyteSelector } from '@dytesdk/react-native-core';
import DyteAudioVisualizer from './DyteAudioVisualizer';
import DyteText from './DyteText';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  size = 'sm',
  states,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  t?: DyteI18n;
}) {
  const { self } = useDyteSelector((m) => m);
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  const muteNotificationSounds = states.prefs.muteNotificationSounds;
  const [enableNotification, setEnableNotification] = useState(
    !muteNotificationSounds
  );
  const [devicesAudio, setAudioDevices] = useState([]);
  useEffect(() => {
    const load = async () => {
      const audio = await meeting.self.getAudioDevices();
      const _devicesAudio = [];
      audio.map((item) => {
        let name =
          item.deviceId[0].toUpperCase() +
          item.deviceId.substring(1, item.deviceId.length);
        _devicesAudio.push({
          label: name,
          value: _devicesAudio.length + 1,
          deviceId: item.deviceId,
          kind: item.kind,
        });
      });
      setAudioDevices(_devicesAudio);
    };
    load();
  }, [meeting]);
  const currentDeviceIndex = devicesAudio
    .map((device, index) => {
      return meeting.self.getCurrentDevices().audio?.deviceId ===
        device.deviceId
        ? index + 1
        : -1;
    })
    .find((val) => val !== -1);
  const selectAudio = (_device) => {
    //Update Radio Button
    devicesAudio.forEach(async (data, index) => {
      if (data.label === _device.label) {
        await meeting.self.setDevice(data);
        return;
      }
    });
  };
  const styles = StyleSheet.create({
    renderContainer: {
      backgroundColor: colors.background[800],
      padding: 10,
    },
    renderText: {
      color: colors.text,
    },
    dropdown: {
      flex: 5,
      backgroundColor: colors.background[800],
      marginLeft: -5,
      marginRight: 10,
      alignItems: 'center',
      borderRadius: 5,
    },
    dropdownContainer: {
      borderColor: colors.background[800],
      borderWidth: 2,
    },
    dropdownSelectedText: {
      color: colors.text,
      marginLeft: 10,
    },
    notification: {
      flexDirection: 'row',
      marginVertical: 40,
      justifyContent: 'space-between',
    },
    visualiser: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.background[800],
      borderRadius: 8,
    },
  });
  const renderItem = (item) => {
    return (
      <View style={styles.renderContainer}>
        <DyteText style={styles.renderText}>{item.label}</DyteText>
      </View>
    );
  };
  const audioOptions = () => {
    return (
      // eslint-disable-next-line react-native/no-inline-styles
      <View style={{ marginLeft: 20 }}>
        {/* eslint-disable-next-line react-native/no-inline-styles */}
        <DyteText size="sm" fontWeight="900" style={{ marginBottom: 10 }}>
          Choose Audio Device
        </DyteText>
        {/* eslint-disable-next-line react-native/no-inline-styles */}
        <View style={{ flexDirection: 'row' }}>
          <Dropdown
            style={styles.dropdown}
            selectedTextStyle={styles.dropdownSelectedText}
            containerStyle={styles.dropdownContainer}
            renderItem={renderItem}
            data={devicesAudio}
            labelField={'label'}
            valueField={'value'}
            value={currentDeviceIndex}
            onChange={selectAudio}
          />
          <View style={styles.visualiser}>
            <DyteAudioVisualizer participant={meeting.self} />
          </View>
        </View>
        <View style={styles.notification}>
          {/* eslint-disable-next-line react-native/no-inline-styles */}
          <View style={{ flexDirection: 'row' }}>
            {/* eslint-disable-next-line react-native/no-inline-styles */}
            <DyteText size="sm" style={{ marginRight: 5 }}>
              Notification Sound
            </DyteText>
          </View>
          {/* eslint-disable-next-line react-native/no-inline-styles */}
          <View style={{ marginRight: 5 }}>
            <Switch
              backgroundActive={colors.brand[300]}
              backgroundInactive={colors.background[700]}
              circleActiveColor={colors.text}
              circleInActiveColor={colors.text}
              circleSize={20}
              // eslint-disable-next-line react-native/no-inline-styles
              innerCircleStyle={{
                alignItems: 'center',
                justifyContent: 'center',
              }}
              renderActiveText={false}
              renderInActiveText={false}
              onValueChange={() => {
                setEnableNotification(!enableNotification);
                setStates({
                  ...states,
                  prefs: {
                    ...states.prefs,
                    muteNotificationSounds: !muteNotificationSounds,
                  },
                });
              }}
              value={enableNotification}
            />
          </View>
        </View>
      </View>
    );
  };
  if (self.mediaPermissions.audio !== 'ACCEPTED') return null;
  return audioOptions();
}
